import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'qaroni-check-details-calendar',
  templateUrl: './check-details-calendar.component.html',
  styleUrls: ['./check-details-calendar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CheckDetailsCalendarComponent {}
